import React, { useContext } from "react";
import { FormContext } from "./Form";
import { Informative } from "../../Inputs/General/Index";
import { ClientArea } from "./Styles";

export default function Client({ value, className = "" }) {
  /**
   * @type {{
   *    document:import("types/typedef/documents").DocumentI
   * }}
   */
  const { document } = useContext(FormContext);

  return (
    <>
      {className !== "" ? (
        <div>
          <Informative
            readonly={true}
            label="Cliente"
            value={!value ? document.customer.socialReason : value}
          />
        </div>
      ) : (
        <ClientArea>
          <Informative
            readonly={true}
            label="Cliente"
            value={!value ? document.customer.socialReason : value}
          />
        </ClientArea>
      )}
    </>
  );
}
